import { StandardError, BaseRestModel } from "ecloud-base-connector";

export abstract class BaseModel extends BaseRestModel {

	constructor(modelData?: any) {
		super();
		if (modelData)
			this.populate(modelData);
	}

	protected static checkPopulateData(modelData: any, requiredFields: string[]): void {
		// Validate model data is not null
		if (!modelData)
			throw new StandardError(null, "Empty model data");

		// Validate required fields not missing from modelData
		for (const requiredField of requiredFields)
			if (!(requiredField in modelData) || modelData[requiredField] === null || modelData[requiredField] === undefined)
				throw new StandardError(null, `Missing key ${requiredField} is required`);
	}

	protected static checkOneOfManyFields(baseData: any, oneOfManyRequiredFiels: string[]): void {
		const hasOneOfManyFields = oneOfManyRequiredFiels.filter((requiredKey: string) =>
			(requiredKey in baseData) && baseData[requiredKey] !== null && baseData[requiredKey] !== undefined
		);
		if (hasOneOfManyFields.length != 1)
			throw `Only one of these fields '${oneOfManyRequiredFiels.join("', '")}' must be present`;
	}

	abstract toJson(): any;
	abstract clone(): BaseModel;
	abstract getChanges(existentModel: BaseModel): any
}